module.exports = __webpack_public_path__ + "static/media/cela.3fdc89ab.jpg";